const CIRCLE = ({ color = "#000", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <circle
      cx={5}
      cy={5}
      r={5}
      style={{
        fill: color,
        stroke: "none",
        strokeWidth: 0,
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default CIRCLE;
